{
  "PHONE_CTRLS": {
    "EXTENSION_BANNER": {
      "TEXT": "L'estensione di Chrome non è installata.",
      "CTA": "Installa estensione"
    },
    "STATUS": {
      "OFFLINE": "Telefono offline",
      "IN_OTHER_TAB": "Telefono connesso in un'altra scheda",
      "CONNECTING": "Connessione in corso...",
      "DISCONNECTING": "Disconnessione in corso...",
      "ONLINE": "Telefono online",
      "DIALING": "Composizione",
      "TRANSFERRING": "Trasferimento in corso...",
      "CONSULTING": "In linea con l'agente",
      "CALLER_ON_HOLD": "Il chiamante è in attesa",
      "BUSY": "Occupato",
      "DND": "DND",
      "UNAVAILABLE": "Non disponibile",
      "REJECTED": "Chiamata rifiutata",
      "CALL_FAILED": "Chiamata fallita"
    },
    "QUEUES": {
      "MORE": "Altre code"
    },
    "TABS": {
      "PHONE": "Telefono",
      "SMS": "SMS",
      "HISTORY": "Cronologia"
    },
    "HISTORY": {
      "OPEN": "Aperte",
      "RECENT": "Recenti",
      "MISSED": "Perse",
      "LOADING": "Caricamento chiamate...",
      "EMPTY": "Nessuna chiamata qui",
      "ERROR": "Impossibile caricare le chiamate",
      "CALL": "Richiama",
      "CALL_STATUS": {
        "BUTTON": "Imposta stato chiamata",
        "TITLE": "Stato chiamata",
        "SEARCH_PLACEHOLDER": "Cerca stati...",
        "LOADING": "Caricamento stati...",
        "NO_OPTIONS": "Non ci sono stati di chiamata configurati",
        "NO_MATCH": "Nessuno stato trovato",
        "OPTIONS_ERROR": "Impossibile caricare gli stati",
        "RETRY": "Riprova",
        "CONFIRM_QUESTION": "Impostare «{status}» e risolvere la conversazione?",
        "CONFIRM": "Conferma",
        "BACK": "Indietro",
        "CANCEL": "Annulla",
        "SAVING": "Salvataggio...",
        "SAVE_ERROR": "Impossibile salvare lo stato",
        "RESOLVE_ERROR": "Stato salvato, ma non è stato possibile risolvere la conversazione"
      }
    },
    "SMS": {
      "NUMBER_PLACEHOLDER": "Numero di telefono, es. +421903000000",
      "BODY_PLACEHOLDER": "Scrivi il tuo messaggio...",
      "SEGMENTS": "({segments} SMS)",
      "SEND": "Invia SMS",
      "SENDING": "Invio in corso...",
      "SENT": "SMS inviato",
      "LOADING": "Caricamento delle caselle SMS...",
      "NO_INBOX": "Questo account non ha una casella SMS, quindi non è possibile inviare l'SMS.",
      "INVALID_NUMBER": "Inserisci il numero in formato internazionale, compreso il + iniziale.",
      "ERROR": "Non è stato possibile inviare l'SMS. Riprova."
    },
    "ACTIONS": {
      "CONNECT": "Connetti",
      "GO_TO_TAB": "Vai a quella scheda",
      "DISCONNECT": "Disconnetti",
      "ANSWER": "Rispondi",
      "HANGUP": "Riaggancia",
      "HOLD": "Metti in attesa",
      "MUTE": "Disattiva microfono",
      "SILENCE": "Silenzia audio",
      "TRANSFER": "Trasferisci",
      "COMPLETE_TRANSFER": "Completa trasferimento",
      "RETURN_TO_CALLER": "Torna al chiamante",
      "CANCEL_TRANSFER": "Annulla trasferimento",
      "DIALPAD": "Mostra tastierino",
      "OPEN_CONVERSATION": "Apri conversazione"
    },
    "NOTIFICATIONS": {
      "INCOMING_CALL": "Chiamata in arrivo",
      "INCOMING_CALL_FROM": "Chiamata in arrivo da {name} ({number})",
      "INCOMING_CALL_FROM_NUMBER": "Chiamata in arrivo da {number}",
      "ANSWER": "Rispondi",
      "DECLINE": "Rifiuta"
    },
    "TRANSFER": {
      "TITLE": "Trasferisci chiamata",
      "PLACEHOLDER": "Inserisci il numero di destinazione del trasferimento...",
      "SEARCH_PLACEHOLDER": "Cerca agenti...",
      "TARGET_PLACEHOLDER": "Destinazione del trasferimento selezionata",
      "CONFIRM": "Trasferisci",
      "MODE_DIRECT": "Trasferisci subito",
      "MODE_CONSULT": "Chiama prima l'agente",
      "CANCEL": "Annulla"
    },
    "QUEUE_BREAK": {
      "CONFIRM_BREAK": "Sei sicuro di voler fare una pausa per tutte le code?",
      "CONFIRM_READY": "Sei sicuro di voler tornare allo stato pronto per tutte le code?",
      "CONFIRM_BREAK_QUEUE": "Sei sicuro di voler uscire dalla coda {queue}?",
      "CONFIRM_READY_QUEUE": "Sei sicuro di voler accedere alla coda {queue}?",
      "LOGIN_TO_QUEUE": "Accedi",
      "LOGOUT_FROM_QUEUE": "Esci",
      "LOGIN_TO_ALL_QUEUES": "Accedi a tutte le code",
      "LOGOUT_FROM_ALL_QUEUES": "Esci da tutte le code",
      "OPTION_LOGOUT": "Esci",
      "OPTION_BREAK": "Pausa",
      "OPTION_LUNCH": "Pranzo",
      "OPTION_AWAY": "Assente",
      "OPTION_DO_NOT_DISTURB": "Non disturbare",
      "OPTION_BUSINESS_TRIP": "Viaggio di lavoro",
      "CONFIRM": "Conferma",
      "CANCEL": "Annulla"
    },
    "CONNECTION_ERROR": {
      "TITLE": "Nessuna connessione al sistema telefonico",
      "MESSAGE": "La tua connessione a Internet sembra non funzionare. Controllala e riprova.",
      "CREDENTIALS_TITLE": "Il sistema telefonico ha rifiutato le tue credenziali",
      "CREDENTIALS_MESSAGE": "Il sistema telefonico ha rifiutato il nome utente o la password salvati nel tuo profilo. Controllali in Impostazioni profilo o chiedi al tuo amministratore.",
      "CONFIGURATION_TITLE": "Le impostazioni del telefono non sono valide",
      "CONFIGURATION_MESSAGE": "Il nome utente SIP o l'indirizzo del server non è in un formato valido, quindi il telefono non può connettersi. Correggilo in Impostazioni profilo.",
      "NETWORK_SHORT": "Connessione non riuscita",
      "CREDENTIALS_SHORT": "Credenziali rifiutate",
      "CONFIGURATION_SHORT": "Impostazioni non valide",
      "RETRY": "Riprova",
      "DISMISS": "Annulla"
    },
    "CONNECTION_QUALITY": "Qualità della connessione",
    "CONNECTION_QUALITY_EXCELLENT": "Eccellente",
    "CONNECTION_QUALITY_GOOD": "Buona",
    "CONNECTION_QUALITY_FAIR": "Discreta",
    "CONNECTION_QUALITY_POOR": "Scarsa",
    "CONNECTION_QUALITY_DISCONNECTED": "Disconnessa"
  },
  "DIAL_REDIRECT": {
    "DIALING": "Composizione di {number}… Puoi chiudere questa scheda.",
    "NO_NUMBER": "Nessun numero fornito. Usa ?number=+420..."
  },
  "PHONE_DIAL": {
    "PLACEHOLDER": "Inserisci numero di telefono...",
    "ACTIONS": {
      "DIAL": "Componi numero",
      "DIAL_FROM": "Scegli il numero da cui chiamare"
    },
    "DIAL_FROM": {
      "TITLE": "Chiama dal numero di una casella"
    },
    "VALIDATION": {
      "REQUIRED": "Il numero di telefono è obbligatorio",
      "INVALID_FORMAT": "Formato del numero di telefono non valido"
    }
  },
  "PHONE_AUDIO": {
    "TITLE": "Impostazioni e test audio",
    "SELECT_DEVICE": "Seleziona dispositivo...",
    "SYSTEM_DEFAULT": "Predefinito di sistema",
    "SAVED": "Salvato",
    "DISCONNECTED_SUFFIX": "non connesso",
    "DEVICE_DISCONNECTED": "Il dispositivo selezionato non è connesso. Le chiamate usano il predefinito di sistema finché non torna disponibile.",
    "MICROPHONE": {
      "TITLE": "Microfono",
      "START_TEST": "Testa microfono",
      "STOP_TEST": "Ferma test",
      "LEVEL": "Livello:",
      "VERDICT": {
        "LISTENING": "Dica qualcosa nel microfono…",
        "SILENT": "Non la si sente. Verifichi che il microfono sia acceso e che sia selezionato quello giusto.",
        "LOW": "La si sente solo debolmente. Scelga un altro microfono o regoli il volume di ingresso nelle impostazioni di sistema.",
        "GOOD": "Buon audio: la si sente bene."
      }
    },
    "SPEAKER": {
      "TITLE": "Altoparlante",
      "TEST": "Testa altoparlante",
      "TESTING": "Test in corso...",
      "VOLUME": "Volume:",
      "USING_DEFAULT": "L'uscita selezionata non è disponibile — riprodotto sull'uscita predefinita di sistema."
    },
    "DONE": "Fatto",
    "ERRORS": {
      "MICROPHONE_ACCESS": "Errore nell'accesso al microfono. Controlla i permessi.",
      "MICROPHONE_PERMISSION_DENIED": "L'accesso al microfono è bloccato. Consentilo nelle impostazioni del sito del browser per usare il telefono.",
      "MICROPHONE_SILENT": "Il microfono non sta captando alcun suono. Controlla le impostazioni audio.",
      "EXTENSION_REQUIRED": "Estensione del telefono non rilevata. Installala o abilitala per usare il microfono.",
      "SPEAKER_TEST": "Errore nel test dell'uscita altoparlante."
    }
  },
  "PHONE_STATUS": {
    "OFFLINE": "Offline",
    "ONLINE": "Online",
    "BUSY": "Occupato"
  },
  "QUEUE_STATUS": {
    "READY": "Pronto",
    "NOT_READY": "Non accetta chiamate",
    "WRAP_UP": "Post-chiamata",
    "BREAK": "Pausa",
    "LUNCH": "Pranzo",
    "AWAY": "Assente",
    "DO_NOT_DISTURB": "Non disturbare",
    "BUSINESS_TRIP": "Viaggio di lavoro",
    "OTHER_CALL": "Altra chiamata",
    "QUEUE_CALL": "Chiamata in coda",
    "OFFLINE": "Offline",
    "ONLINE": "Online",
    "NO_ACCESS": "Nessun telefono",
    "PARTIALLY_READY": "Parzialmente pronto",
    "MIXED": "Misto",
    "CHAT_ONLINE": "Online (chat)",
    "CHAT_BUSY": "Occupato (chat)",
    "CHAT_OFFLINE": "Offline (chat)"
  }
}
